import ComponentHelper from '../../../../supers/ComponentHelper';
import RESTService from '../../../../services/RESTService';
import { notify } from 'react-notify-toast';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import React from 'react';
import './change-pass-modal.css';

const connect = new RESTService();

class ChangePassModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.initialState = {
			currentPass: '',
			newPass: '',
			newPassAgain: '',
			newPassValidation: {
				validLength: false,
				containsNumber: false,
				containsLowercase: false,
				containsUppercase: false
			},
			validationErrors: [],
			updateStatus: 'init',
			updateError: null
		};
		this.state = this.initialState;
	}

	handleFormChange = e => {
		const { name, value } = e.target;

		this.setState(state => ({
			[name]: value,
			newPassValidation: name === 'newPass' ? this.validatePass(value) : state.newPassValidation
		}));
	};

	validatePass = value => ({
		validLength: value.length >= 8,
		containsNumber: !!value.match(/[0-9]/),
		containsLowercase: !!value.match(/[a-z]/),
		containsUppercase: !!value.match(/[A-Z]/)
	});

	validate = () => {
		const { currentPass, newPass, newPassAgain, newPassValidation } = this.state;
		let errors = [];
		if (!currentPass) errors.push('Current password is required.');
		if (newPass) {
			if (Object.values(newPassValidation).filter(v => !v).length > 0) {
				errors.push('Password format is invalid.');
			} else {
				if (newPassAgain && newPass !== newPassAgain) errors.push('Passwords are not equal.');
			}
		} else {
			errors.push('New password is required.');
		}
		if (!newPassAgain) errors.push('Repeat password is required.');
		return errors;
	};

	handleSubmit = e => {
		e.preventDefault();
		const validationErrors = this.validate();
		if (validationErrors.length) return this.setState({ validationErrors });
		this.setState({ updateStatus: 'pending', updateError: null, validationErrors: [] });
		connect
			.updateUserPassword({
				currentPass: this.state.currentPass,
				newPass: this.state.newPass
			})
			.then(() => this.setState(this.initialState))
			.then(this.props.onRequestClose)
			.then(() => notify.show('Password was updated', 'success'))
			.catch(({ message }) => this.setState({ updateStatus: 'failure', updateError: message }));
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) this.setState(this.initialState);
	}

	render() {
		const { currentPass, newPass, newPassAgain, newPassValidation, validationErrors, updateStatus, updateError } = this.state;
		const { onRequestClose, isOpen } = this.props;

		const amountOfErrors = validationErrors.length;

		return (
			<Modal
				ariaHideApp={false}
				onRequestClose={onRequestClose}
				contentLabel="Modal"
				isOpen={isOpen}
				style={{ content: { left: '50%', right: 'auto', bottom: 'auto', maxWidth: '400px', transform: 'translateX(-50%)' } }}
				overlayClassName="dialog-modal-overlay"
			>
				<form className="change-pass-modal" onSubmit={this.handleSubmit} autoComplete="off">
					<h1>Change password</h1>
					<div className="form-control ">
						<label htmlFor="currentPass">
							<div className="label label--required">Current password</div>
							<input name="currentPass" type="password" value={currentPass} onChange={this.handleFormChange} />
						</label>
					</div>
					<div className="form-control ">
						<label htmlFor="newPass">
							<div className="label label--required">New password</div>
							<input name="newPass" type="password" value={newPass} onChange={this.handleFormChange} />
						</label>
						<ul className="pass-validations">
							<li data-valid={newPassValidation.validLength}>Is 8 characters or longer</li>
							<li data-valid={newPassValidation.containsNumber}>Contains 1 number</li>
							<li data-valid={newPassValidation.containsLowercase}>Contains 1 lowercase letter</li>
							<li data-valid={newPassValidation.containsUppercase}>Contains 1 uppercase letter</li>
						</ul>
					</div>
					<div className="form-control ">
						<label htmlFor="newPassAgain">
							<div className="label label--required">Repeat new password</div>
							<input name="newPassAgain" type="password" value={newPassAgain} onChange={this.handleFormChange} />
						</label>
					</div>

					{amountOfErrors > 0 && (
						<ul className="validation-errors">
							{validationErrors.map((txt, i) => (
								<li key={i}>
									<i className="mdi mdi-alert-octagon" /> {txt}
								</li>
							))}
						</ul>
					)}

					{updateStatus === 'failure' && <p className="error-msg">Error: {updateError}</p>}

					<div className="btn-ctn">
						<button className="btn cancel-btn" onClick={onRequestClose} type="button" disabled={updateStatus === 'pending'}>
							Cancel
						</button>
						<button className="btn primary" type="submit" disabled={updateStatus === 'pending'}>
							{updateStatus === 'pending' ? 'Saving...' : 'Save'}
						</button>
					</div>
				</form>
			</Modal>
		);
	}
}

ChangePassModal.propTypes = {
	onRequestClose: PropTypes.func.isRequired,
	isOpen: PropTypes.bool.isRequired
};

export default ChangePassModal;



// WEBPACK FOOTER //
// ./src/views/user-profile/user-info/change-pass-modal/ChangePassModal.js